import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import GetUserInfoService from "../../../../service/GetUserInfoService";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "../StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import ProductService from "../../../../service/ProductService";
import { FilterMatchMode } from "primereact/api";
import { TabView } from "primereact/tabview";
import { TabPanel } from "primereact/tabview";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { formatPrice } from "../../../../utilities/formatPrice";
import { useHistory } from "react-router-dom";

const SituationColumn = ({ status }) => {
  return (
    <div style={{ minWidth: "120px" }}>
      {status === "PUBLISHED" ? (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#46a748" }}
        >
          {localeText("published")}
        </span>
      ) : status === "UNPUBLISHED" ? (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#eb4034" }}
        >
          {localeText("unpublished")}
        </span>
      ) : (
        <span
          className="team-member-role text-0 p-1 border-round block text-center"
          style={{ backgroundColor: "#607D8B" }}
        >
          {localeText("archivedProduct")}
        </span>
      )}
    </div>
  );
};

const VisibilityColumn = ({ status, onClickPublished, onClickUnpublished }) => {
  return (
    <div>
      {status === "PUBLISHED" ? (
        <Button
          icon="pi pi-eye-slash"
          onClick={onClickUnpublished}
          className="p-button-danger p-button-rounded"
          style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
          label={localeText("unpublish")}
        />
      ) : status === "DELETED" ? (
        <div className="flex gap-2">
          <Button
            icon="pi pi-eye-slash"
            onClick={onClickUnpublished}
            className="p-button-danger p-button-rounded"
            style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
            label={localeText("unpublish")}
          />
          <Button
            icon="pi pi-upload"
            onClick={onClickPublished}
            className="p-button-success p-button-rounded"
            style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
            label={localeText("publish")}
          />
        </div>
      ) : (
        <Button
          icon="pi pi-upload"
          onClick={onClickPublished}
          className="p-button-success p-button-rounded"
          style={{ fontSize: "1rem", width: "100%", minWidth: "150px" }}
          label={localeText("publish")}
        />
      )}
    </div>
  );
};

const filters2 = {
  title: { value: null, matchMode: FilterMatchMode.CONTAINS },
};

const FringeBenefitsList = () => {
  const getUserInfoService = new GetUserInfoService();
  const productService = new ProductService();
  const [products, setProducts] = useState([]);
  const [retryFetchProducts, setRetryFetchProducts] = useState(false);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);

  const [tableIndex, setTableIndex] = useState(0);
  const [publishedProducts, setPublishedProducts] = useState([]);
  const [unpublishedProducts, setUnpublishedProducts] = useState([]);
  const [archivedProducts, setArchivedProducts] = useState([]);

  const navigate = useHistory();

  async function FetchProducts(cancel) {
    try {
      setLoading(true);

      const res = await getUserInfoService.getMyFringeBenefits();

      if (cancel) return;

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
      } else {
        setProducts(res.result.filter((product) => product.productStatus !== "DELETED"));
        setPublishedProducts(res.result.filter((product) => product.productStatus === "PUBLISHED"));
        setUnpublishedProducts(
          res.result.filter((product) => product.productStatus === "UNPUBLISHED")
        );
        setArchivedProducts(res.result.filter((product) => product.productStatus === "DELETED"));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let cancel = false;

    FetchProducts(cancel);

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let cancel = false;

    if (retryFetchProducts) {
      FetchProducts(cancel);
      setRetryFetchProducts(false);
    }

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryFetchProducts]);

  async function goToEditVoucher(id) {
    navigate.push(`/dashboard-edit-fringe-benefit?productId=${id}`);
  }

  async function modifyStatus(product, status) {
    try {
      setLoading(true);

      const fringeBenefit = {
        title: product.title,
        rules: product.rules,
        amountAvailable: product.amountAvailable,
        currency: product.currency,
        imageid1: product.imageid1,
        price: product.price,
        subCategoryId: product.subCategory.id,
        username: product.user.username,
        productStatus: status,
        id: product.id,
      };

      const res = await productService.postEditFringeBenefit(fringeBenefit);

      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
      } else {
        toast.current.show({
          severity: status === "PUBLISHED" ? "success" : "info",
          summary: status === "PUBLISHED" ? localeText("success") : localeText("info"),
          detail:
            status === "PUBLISHED"
              ? localeText("productPublishedSuccessfully")
              : localeText("productUnpublishedSuccessfully"),
          life: 6000,
        });

        const resProducts = await getUserInfoService.getMyFringeBenefits();

        if (resProducts.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === resProducts.messageCode).message,
            life: 6000,
          });
          setLoading(false);
        } else {
          setProducts(resProducts.result.filter((product) => product.productStatus !== "DELETED"));
          setPublishedProducts(
            resProducts.result.filter((product) => product.productStatus === "PUBLISHED")
          );
          setUnpublishedProducts(
            resProducts.result.filter((product) => product.productStatus === "UNPUBLISHED")
          );
          setArchivedProducts(
            resProducts.result.filter((product) => product.productStatus === "DELETED")
          );
        }

        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  return (
    <div>
      <Toast ref={toast} />

      <div className="card border-1 border-300">
        <h3 className="my-4">{localeText("fringeBenefits")}</h3>
        <hr />

        <TabView activeIndex={tableIndex} onTabChange={(e) => setTableIndex(e.index)}>
          <TabPanel header={localeText("all")}>
            <DataTable
              className="mt-4 mb-6 p-datatable-customers"
              value={products}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              dataKey="id"
              filters={filters2}
              filterDisplay="row"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column
                style={{ width: "10%" }}
                header={localeText("productImage")}
                body={(rowData) => {
                  return (
                    <AdvancedImage
                      cldImg={cloudinaryInstance
                        .image(rowData.imageid1)
                        .format("webp")
                        .resize(fill().width(600).height(600))}
                      height={75}
                      style={{ border: "1px solid #E0E0E0" }}
                      className="border-round product-thumbnail"
                    />
                  );
                }}
              />
              <Column
                field="title"
                header={localeText("title")}
                filter
                filterPlaceholder={localeText("searchByTitle")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                header={localeText("price")}
                body={(product) => {
                  return (
                    <p>
                      {product.currency} {formatPrice(product.price)}
                    </p>
                  );
                }}
              />
              <Column
                header={localeText("productStatus")}
                body={(rowData) => {
                  return <SituationColumn status={rowData.productStatus} />;
                }}
              />
              <Column field="amountAvailable" header={localeText("stock")} />
              <Column
                header={localeText("edit")}
                body={(rowData) => {
                  return (
                    <Button
                      icon="pi pi-pencil"
                      className="p-button-warning p-button-rounded"
                      onClick={() => goToEditVoucher(rowData.id)}
                      style={{ textSize: "4em" }}
                    />
                  );
                }}
              />
              <Column
                header={localeText("archived")}
                body={(rowData) => {
                  return (
                    <div className="flex justify-content-center">
                      <Button
                        icon="pi pi-inbox"
                        className="p-button-secondary p-button-rounded"
                        onClick={() => modifyStatus(rowData, "DELETED")}
                        style={{ textSize: "4em" }}
                      />
                    </div>
                  );
                }}
              />
              <Column
                header={localeText("visibility")}
                body={(rowData) => {
                  return (
                    <VisibilityColumn
                      status={rowData.productStatus}
                      onClickPublished={() => modifyStatus(rowData, "PUBLISHED")}
                      onClickUnpublished={() => modifyStatus(rowData, "UNPUBLISHED")}
                    />
                  );
                }}
              />
            </DataTable>
          </TabPanel>

          <TabPanel header={localeText("published")}>
            <DataTable
              className="mt-4 mb-6 p-datatable-customers"
              value={publishedProducts}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              dataKey="id"
              filters={filters2}
              filterDisplay="row"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column
                style={{ width: "10%" }}
                header={localeText("productImage")}
                body={(rowData) => {
                  return (
                    <Link to={`/product/${rowData.id}`}>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(rowData.imageid1)
                          .format("webp")
                          .resize(fill().width(600).height(600))}
                        height={75}
                        style={{ border: "1px solid #E0E0E0" }}
                        className="border-round product-thumbnail"
                      />
                    </Link>
                  );
                }}
              />
              <Column
                field="title"
                header={localeText("title")}
                filter
                filterPlaceholder={localeText("searchByTitle")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                header={localeText("price")}
                body={(product) => {
                  return (
                    <p>
                      {product.currency} {formatPrice(product.price)}
                    </p>
                  );
                }}
              />
              <Column
                header={localeText("productStatus")}
                body={(rowData) => {
                  return <SituationColumn status={rowData.productStatus} />;
                }}
              />
              <Column field="amountAvailable" header={localeText("stock")} />
              <Column
                header={localeText("edit")}
                body={(rowData) => {
                  return (
                    <Button
                      icon="pi pi-pencil"
                      className="p-button-warning p-button-rounded"
                      onClick={() => goToEditVoucher(rowData.id)}
                      style={{ textSize: "4em" }}
                    />
                  );
                }}
              />
              <Column
                header={localeText("archived")}
                body={(rowData) => {
                  return (
                    <div className="flex justify-content-center">
                      <Button
                        icon="pi pi-inbox"
                        className="p-button-secondary p-button-rounded"
                        onClick={() => modifyStatus(rowData, "DELETED")}
                        style={{ textSize: "4em" }}
                      />
                    </div>
                  );
                }}
              />
              <Column
                header={localeText("visibility")}
                body={(rowData) => {
                  return (
                    <VisibilityColumn
                      status={rowData.productStatus}
                      onClickPublished={() => modifyStatus(rowData, "PUBLISHED")}
                      onClickUnpublished={() => modifyStatus(rowData, "UNPUBLISHED")}
                    />
                  );
                }}
              />
            </DataTable>
          </TabPanel>

          <TabPanel header={localeText("unpublished")}>
            <DataTable
              className="mt-4 mb-6 p-datatable-customers"
              value={unpublishedProducts}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              dataKey="id"
              filters={filters2}
              filterDisplay="row"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column
                style={{ width: "10%" }}
                header={localeText("productImage")}
                body={(rowData) => {
                  return (
                    <Link to={`/product/${rowData.id}`}>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(rowData.imageid1)
                          .format("webp")
                          .resize(fill().width(600).height(600))}
                        height={75}
                        style={{ border: "1px solid #E0E0E0" }}
                        className="border-round product-thumbnail"
                      />
                    </Link>
                  );
                }}
              />
              <Column
                field="title"
                header={localeText("title")}
                filter
                filterPlaceholder={localeText("searchByTitle")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                header={localeText("price")}
                body={(product) => {
                  return (
                    <p>
                      {product.currency} {formatPrice(product.price)}
                    </p>
                  );
                }}
              />
              <Column
                header={localeText("productStatus")}
                body={(rowData) => {
                  return <SituationColumn status={rowData.productStatus} />;
                }}
              />
              <Column field="amountAvailable" header={localeText("stock")} />
              <Column
                header={localeText("edit")}
                body={(rowData) => {
                  return (
                    <Button
                      icon="pi pi-pencil"
                      className="p-button-warning p-button-rounded"
                      onClick={() => goToEditVoucher(rowData.id)}
                      style={{ textSize: "4em" }}
                    />
                  );
                }}
              />
              <Column
                header={localeText("archived")}
                body={(rowData) => {
                  return (
                    <div className="flex justify-content-center">
                      <Button
                        icon="pi pi-inbox"
                        className="p-button-secondary p-button-rounded"
                        onClick={() => modifyStatus(rowData, "DELETED")}
                        style={{ textSize: "4em" }}
                      />
                    </div>
                  );
                }}
              />
              <Column
                header={localeText("visibility")}
                body={(rowData) => {
                  return (
                    <VisibilityColumn
                      status={rowData.productStatus}
                      onClickPublished={() => modifyStatus(rowData, "PUBLISHED")}
                      onClickUnpublished={() => modifyStatus(rowData, "UNPUBLISHED")}
                    />
                  );
                }}
              />
            </DataTable>
          </TabPanel>

          <TabPanel header={localeText("archived")}>
            <DataTable
              className="mt-4 mb-6 p-datatable-customers"
              value={archivedProducts}
              paginator
              responsiveLayout="scroll"
              loading={loading}
              dataKey="id"
              filters={filters2}
              filterDisplay="row"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate={localeText("showingFirstToLast")}
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
            >
              <Column
                style={{ width: "10%" }}
                header={localeText("productImage")}
                body={(rowData) => {
                  return (
                    <Link to={`/product/${rowData.id}`}>
                      <AdvancedImage
                        cldImg={cloudinaryInstance
                          .image(rowData.imageid1)
                          .format("webp")
                          .resize(fill().width(600).height(600))}
                        height={75}
                        style={{ border: "1px solid #E0E0E0" }}
                        className="border-round product-thumbnail"
                      />
                    </Link>
                  );
                }}
              />
              <Column
                field="title"
                header={localeText("title")}
                filter
                filterPlaceholder={localeText("searchByTitle")}
                filters={filters2}
                filterDisplay="row"
              />
              <Column
                header={localeText("price")}
                body={(product) => {
                  return (
                    <p>
                      {product.currency} {formatPrice(product.price)}
                    </p>
                  );
                }}
              />
              <Column
                header={localeText("productStatus")}
                body={(rowData) => {
                  return <SituationColumn status={rowData.productStatus} />;
                }}
              />
              <Column field="amountAvailable" header={localeText("stock")} />
              <Column
                header={localeText("edit")}
                body={(rowData) => {
                  return (
                    <Button
                      icon="pi pi-pencil"
                      className="p-button-warning p-button-rounded"
                      onClick={() => goToEditVoucher(rowData.id)}
                      style={{ textSize: "4em" }}
                    />
                  );
                }}
              />
              <Column
                header={localeText("visibility")}
                body={(rowData) => {
                  return (
                    <VisibilityColumn
                      status={rowData.productStatus}
                      onClickPublished={() => modifyStatus(rowData, "PUBLISHED")}
                      onClickUnpublished={() => modifyStatus(rowData, "UNPUBLISHED")}
                    />
                  );
                }}
              />
            </DataTable>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default FringeBenefitsList;
